import * as React from 'react';
import { Component } from 'react';
import { Theme } from '../models/Theme';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';

const StyledVisuallyHiddenDiv = styled<any, any>(
    'div',
    'styledVisuallyHiddenDiv',
    'visuallyHiddenWrapper'
)`
    ${propStyles};
`;

StyledVisuallyHiddenDiv.defaultProps = {
    position: 'absolute',
    left: '-10000px',
    top: 'auto',
    width: '1px',
    height: '1px',
    overflow: 'hidden',
};

interface VisuallyHiddenWrapperProps {
    theme?: Theme;
    as?: keyof HTMLElementTagNameMap;
}

class VisuallyHiddenWrapper extends Component<VisuallyHiddenWrapperProps, any> {
    render() {
        const { children, theme, as } = this.props;
        return (
            <StyledVisuallyHiddenDiv as={as} {...theme.VisuallyHidden}>
                {children}
            </StyledVisuallyHiddenDiv>
        );
    }
}

export default withTheme(VisuallyHiddenWrapper);



// WEBPACK FOOTER //
// ./src/Components/VisuallyHiddenWrapper.tsx